// extracted by mini-css-extract-plugin
module.exports = {"givePriority":"styles_givePriority__3DAU1","comparisonSelect":"styles_comparisonSelect__3PZ1D","input":"styles_input__2bARl"};